import React, { useState } from 'react';
import { FaEdit, FaSave, FaCopy, FaTrash } from 'react-icons/fa';
import useTemplate from './hooks/useTemplate';
function TopHeaderComponent({ id, name = null }) {
  const [designName, setDesignName] = useState(name);
  const [isEditing, setIsEditing] = useState(false);
  const [tempName, setTempName] = useState(designName);
  const { updateName } = useTemplate();

  const handleSave = () => {
    console.log('Save action', id);
    updateName({ id, name: tempName });
    setIsEditing(false);
    setDesignName(tempName);
    // Handle save action here
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && tempName.trim() !== '') {
      handleSave();
    }
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-6  mb-4 space-y-4">
      {/* Breadcrumb Navigation */}

      {/* Title and Editable Input aligned to the left */}
      <div className="flex items-center space-x-4 space-btween">
        {isEditing ? (
          <div className="flex items-center space-x-3">
            <input
              value={tempName}
              onChange={(e) => setTempName(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Enter design name"
              className="border border-gray-300 focus:border-blue-500 p-2 rounded-md shadow-sm transition-all focus:outline-none focus:ring-2 focus:ring-blue-200 max-w-xs text-black"
              aria-label="Edit design name"
            />
            <button
              onClick={handleSave}
              disabled={tempName.trim() === designName || tempName.trim() === ''}
              className={`flex items-center px-4 py-2 rounded-md transition-all focus:outline-none focus:ring-2 ${tempName.trim() !== designName && tempName.trim() !== ''
                ? 'bg-blue-500 text-white hover:bg-blue-600 focus:ring-blue-400'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                }`}
              aria-label="Save design name"
            >
              <FaSave className="mr-2" /> Save
            </button>
          </div>
        ) : (
          <div className="flex items-center space-x-3">
            <h1 className="text-2xl font-bold text-black">{designName}</h1>
            <button
              onClick={() => setIsEditing(true)}
              className="flex items-center text-blue-500 hover:text-blue-600 transition-all focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-lg p-2"
              aria-label="Edit design name"
              title="Edit design name"
            >
              <FaEdit className="mr-1" /> Edit
            </button>
          </div>
        )}
        <div className="flex items-center space-x-4">
          <span className="flex items-center text-gray-500 transition-all">
            <FaCopy className="mr-1" /> Copy
          </span>
          <span className="flex items-center text-red-500 transition-all">
            <FaTrash className="mr-1" /> Delete
          </span>


        </div>
      </div>

      <div className="text-gray-500 text-sm flex items-center space-x-2">
        <a href='/authors'>Templates</a>
        <span className="text-black">/</span>
        <span className="text-black font-semibold">{designName}</span>
      </div>

    </div>
  );
}

export default TopHeaderComponent;
